import React from 'react';

/**
 * Floating tooltip shown when the user hovers an event pill on the
 * schedule. Anchored at an absolute viewport coordinate.
 */
export function EventTooltip({ tip }) {
  if (!tip) return null;
  return (
    <div
      className="wv-event-tooltip"
      style={{ left: tip.x, top: tip.y }}
    >
      {tip.content}
    </div>
  );
}
